import { useContext, useState } from 'react'
import { useTranslation } from 'react-i18next'

import { Alert, Button, ButtonWithSpinner, Modal, NotesInput } from '@reveni-io/reveni-ui'

import AppContext from '@/common/context/app.context'
import ExchangeOrderAsDraftSelector from '@/returns/components/ExchangeOrderAsDraftSelector/ExchangeOrderAsDraftSelector'
import { statuses, transactionTypes } from '@/returns/constants'
import useIssueExchangeOrderProcessing from '@/returns/hooks/useIssueExchangeOrderProcessing/useIssueExchangeOrderProcessing'

import InfoMessage from './InfoMessage/InfoMessage'
import ReasonSelector from './ReasonSelector/ReasonSelector'
import * as Styles from './styles'

const RejectMultipleRefundsModal = ({
  show,
  onClose,
  rejecting,
  onReject,
  rejectReasons,
  notUsableOrders,
  selectedOrders,
  ordersWithRequestedProducts,
  allowsExchangeOrderProcessing,
  allowsUpsells,
}) => {
  const { info } = useContext(AppContext)

  const [reason, setReason] = useState(null)
  const [notes, setNotes] = useState('')

  const { issueExchangeOrderProcessing, setIssueExchangeOrderProcessing } = useIssueExchangeOrderProcessing(
    info?.selectedStore,
    allowsExchangeOrderProcessing,
    transactionTypes.exchange
  )

  const { t } = useTranslation()

  const handleReasonChange = e => {
    setReason(e.target.value)
  }

  const isFormValid = () => {
    if (reason === null) return false

    return true
  }

  const onConfirm = () => {
    onReject({
      reason,
      notes: notes === '' ? null : notes,
      status: statuses.rejected,
      issueExchangeOrderProcessing,
    })
  }

  const handleChangeNotes = e => {
    setNotes(e.target.value)
  }

  return (
    <Modal
      show={show}
      size="l"
      onClose={onClose}
      actions={
        <Styles.ActionsContainer>
          <Button variant="outlined" onClick={onClose}>
            {t('Cancelar')}
          </Button>
          <ButtonWithSpinner
            onClick={onConfirm}
            loading={rejecting}
            loadingLabel={t('Confirmando cambios')}
            defaultLabel={t('Confirmar cambios')}
            disabled={rejecting || !isFormValid()}
          />
        </Styles.ActionsContainer>
      }
      title={t('Rechazar productos')}
    >
      <InfoMessage notUsableOrders={notUsableOrders} selectedOrders={selectedOrders} />
      <Styles.SelectContainer>
        <ReasonSelector reasons={rejectReasons} selectedReason={reason} onChange={handleReasonChange} />
        <NotesInput onChange={handleChangeNotes} label={t('Notas')} />
      </Styles.SelectContainer>

      {allowsExchangeOrderProcessing && allowsUpsells && (
        <ExchangeOrderAsDraftSelector
          ordersWithRequestedProducts={ordersWithRequestedProducts}
          checked={issueExchangeOrderProcessing}
          onChange={setIssueExchangeOrderProcessing}
        />
      )}

      <Styles.AlertContainer>
        <Alert type="warning">{t('Esta acción no se podrá deshacer. ¿Quieres continuar?')}</Alert>
      </Styles.AlertContainer>
    </Modal>
  )
}

export default RejectMultipleRefundsModal
